import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
	GET_SCHEDULED_REMINDERS,
	SG_GET_SCHEDULED_REMINDERS,
	FETCH_SCHEDULED_REMINDER,
	SG_FETCH_SCHEDULED_REMINDER,
	ADD_SCHEDULED_REMINDER,
	SG_ADD_SCHEDULED_REMINDER,
	EDIT_SCHEDULED_REMINDER,
	SG_EDIT_SCHEDULED_REMINDER,
	DELETE_SCHEDULED_REMINDER,
	SG_DELETE_SCHEDULED_REMINDER,
} from "constants/actions";

/* Scheduled Reminders */

function* loadScheduledReminders(action) {
	try {
		const json = yield call(api.GET_APV2_SCHEDULED_REMINDERS, action.payload);
		yield put({ type: GET_SCHEDULED_REMINDERS, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* scheduledRemindersLoad() {
	yield takeLatest(SG_GET_SCHEDULED_REMINDERS, loadScheduledReminders);
}

function* fetchScheduledReminder(action) {
	try {
		const json = yield call(api.FETCH_APV2_SCHEDULED_REMINDER, action.payload);
		yield put({ type: FETCH_SCHEDULED_REMINDER, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* scheduledReminderFetch() {
	yield takeLatest(SG_FETCH_SCHEDULED_REMINDER, fetchScheduledReminder);
}

function* addScheduledReminder(action) {
	try {
		const json = yield call(api.ADD_APV2_SCHEDULED_REMINDER, action.payload);
		yield put({ type: ADD_SCHEDULED_REMINDER, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* scheduledReminderAdd() {
	yield takeLatest(SG_ADD_SCHEDULED_REMINDER, addScheduledReminder);
}

function* editScheduledReminder(action) {
	try {
		const json = yield call(api.EDIT_APV2_SCHEDULED_REMINDER, action.payload);
		yield put({ type: EDIT_SCHEDULED_REMINDER, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* scheduledReminderEdit() {
	yield takeLatest(SG_EDIT_SCHEDULED_REMINDER, editScheduledReminder);
}

function* deleteScheduledReminder(action) {
	try {
		const json = yield call(api.DELETE_APV2_SCHEDULED_REMINDER, action.payload);
		yield put({ type: DELETE_SCHEDULED_REMINDER, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* scheduledReminderDelete() {
	yield takeLatest(SG_DELETE_SCHEDULED_REMINDER, deleteScheduledReminder);
}

export default function* index() {
	yield all([
		scheduledRemindersLoad(),
		scheduledReminderFetch(),
		scheduledReminderAdd(),
		scheduledReminderEdit(),
		scheduledReminderDelete(),
	]);
}
